module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_main",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "home"
    }
  }, [_c('el-container', {
    staticClass: "con_section"
  }, [_c('el-header', {
    staticClass: "blueheader"
  }, [_c('el-row', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('h2', {
    staticClass: "headlogo"
  }, [_vm._v("美团安全修复提示（Meituan Security Fix Guide）")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "float": "right"
    }
  }, [_c('el-dropdown', {
    staticStyle: {
      "height": "60px"
    },
    attrs: {
      "placement": "top",
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [_c('img', {
    staticClass: "el-dropdown-link",
    staticStyle: {
      "margin": "10px",
      "border-radius": "50%",
      "width": "40px",
      "height": "auto"
    },
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "disabled": _vm.dropdown_item.disabled
    }
  }, [_vm._v(_vm._s(_vm.userName) + " " + _vm._s(_vm.mis_id) + "\n                                ")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "2-0",
      "divided": _vm.dropdown_item.divided
    }
  }, [_vm._v("退出")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "float": "right"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "whitelist_apply"
    },
    on: {
      "click": _vm.whitelist_apply
    }
  }, [_vm._v("\n                                白名单申请 ( Whitelist Application )\n                            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "float": "right",
      "padding": "0 20px"
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleLanguageChange
    }
  }, [_c('span', {
    staticClass: "lang-switcher"
  }, [_c('i', {
    staticClass: "el-icon-global"
  }), _vm._v("\n                          Language"), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.languages), function(lang) {
    return _c('el-dropdown-item', {
      key: lang.value,
      class: {
        'selected': lang.value === _vm.currentLang
      },
      attrs: {
        "command": lang.value
      }
    }, [_vm._v("\n                            " + _vm._s(lang.label) + "\n                          ")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.is_manager) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "float": "right",
      "padding": "0 20px"
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    },
    on: {
      "command": _vm.handleMenuSelect
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("\n                                      菜单管理\n                                  "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "addItem"
    }
  }, [_vm._v("添加菜单")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "updateItem"
    }
  }, [_vm._v("编辑菜单")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "deleteItem"
    }
  }, [_vm._v("删除菜单")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "addLangIndex"
    }
  }, [_vm._v("添加页面语言映射")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-container', {
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-scrollbar', [_c('el-aside', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical",
    staticStyle: {
      "height": "calc(100% - 40px)",
      "overflow-y": "auto",
      "width": "300px"
    },
    attrs: {
      "default-active": _vm.activeItem,
      "default-openeds": _vm.openItems,
      "unique-opened": ""
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.documentItems), function(item) {
    return _c('el-submenu', {
      attrs: {
        "index": item.value + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v(_vm._s(item.label))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('div', [(child.children == null) ? _c('el-menu-item', {
        staticStyle: {
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "white-space": "nowrap"
        },
        attrs: {
          "index": child.value + ''
        }
      }, [_vm._v("\n                                                " + _vm._s(child.label) + "\n                                            ")]) : _c('el-submenu', {
        attrs: {
          "index": child.value + ''
        }
      }, [_c('template', {
        slot: "title"
      }, [_c('i', {
        staticClass: "el-icon-menu"
      }), _vm._v(_vm._s(child.label))]), _vm._v(" "), _vm._l((child.children), function(childOne) {
        return _c('div', [(childOne.children == null) ? _c('el-menu-item', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "index": childOne.value + ''
          }
        }, [_vm._v("\n                                                        " + _vm._s(childOne.label) + "\n                                                    ")]) : _c('el-submenu', {
          attrs: {
            "index": childOne.value + ''
          }
        }, [_c('template', {
          slot: "title"
        }, [_c('i', {
          staticClass: "el-icon-menu"
        }), _vm._v(_vm._s(childOne.label) + "\n                                                        ")]), _vm._v(" "), _vm._l((childOne.children), function(childTwo) {
          return _c('el-menu-item', {
            attrs: {
              "index": childTwo.value + ''
            }
          }, [_vm._v(_vm._s(childTwo.label) + "\n                                                        ")])
        })], 2)], 1)
      })], 2)], 1)
    })], 2)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-main', {
    staticClass: "home_main"
  }, [_c('div', {
    staticClass: "router-view-container"
  }, [_c('router-view')], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33358d44!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 637
// module chunks = 1